"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CREDIT_NOTES = void 0;
var CREDIT_NOTES = {
  TEXT__TOTAL_AMOUNT: 'creditNotes-span-totalAmount',
  TEXT__CREDIT_NOTE_NUMBER: 'creditNotes-span-creditNoteNumber',
  TEXT__ORDER_NUMBER: 'creditNotes-span-orderNumber',
  TEXT__CUSTOMER: 'creditNotes-span-customer',
  TEXT__DATE: 'creditNotes-span-date',
  TEXT__STATUS: 'creditNotes-span-status',
  TEXT__AMOUNT: 'creditNotes-span-amount',
  BUTTON__ADD_NEW_CREDIT_NOTE: 'creditNotes-button-addNewCreditNote',
  BUTTON__EXPORT: 'creditNotes-button-export',
  BUTTON__EXPORT_PDF: 'creditNotesExport-button-exportPDF',
  BUTTON__EXPORT_CSV: 'creditNotesExport-button-exportCSV',
  BUTTON__FILTERS: 'creditNotes-button-filters',
  INPUT__SEARCH_FILTER: 'creditNotesFilters-input-search',
  BUTTON__CUSTOMER_FILTER: 'creditNotesFilters-button-customer',
  BUTTON__DATE_RANGE_FILTER: 'creditNotesFilters-button-dateRange',
  LABEL__STATUS_FILTER: 'creditNotesFilters-label-status',
  BUTON__CANCEL_FILTER: 'creditNotesFilters-button-cancel',
  BUTTON__APPLY_FILTER: 'creditNotesFilters-button-apply',
  BUTTON__CLEAR_FILTER: 'creditNotesFilters-button-clear'
};
exports.CREDIT_NOTES = CREDIT_NOTES;